import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal } from "@/components/Reveal";

export default function Faq({ faq }) {
  if (!faq?.length) return null;
  return (
    <section id="faq" className="mx-auto max-w-4xl scroll-mt-24 px-4 py-20 sm:px-8 lg:py-32" data-testid="faq-section">
      <Reveal>
        <p className="eyebrow mb-4">Good to Know</p>
        <h2 className="font-serif text-2xl leading-snug tracking-tight text-cream sm:text-3xl lg:text-4xl">
          Questions, <span className="italic text-copper-gradient">answered.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="mt-10">
          {faq.map((f, i) => (
            <AccordionItem key={f.id || i} value={`faq-${i}`} className="border-white/10">
              <AccordionTrigger data-testid={`faq-question-${i}`} className="text-left font-serif text-lg text-cream hover:text-copper-300 hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm font-light leading-relaxed text-cream-muted">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </section>
  );
}
